import React, { useEffect, useState } from 'react';
import {
  makeStyles,
  InputLabel,
  TextField,
  Select,
  FormControl,
  MenuItem
} from '@material-ui/core';
import { t } from 'src/shared/literals';
import Autocomplete from '@material-ui/lab/Autocomplete';

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: '200px',
    margin: theme.spacing(1)
  },
  formControlFullWidth: {
    width: '99%',
    margin: theme.spacing(1)
  },
  selectField: {
    margin: 2,
    paddingTop: '17px'
  }
}));

const FormSelectField = ({ field, handleChangeField }) => {
  const classes = useStyles();

  const { name, value, options, readonly, errorMessage, fullWidth } = field;
  const [fieldValue, setFieldValue] = useState('');
  const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);

  const getAutoCompleteOptions = () =>
    options.map((option) => {
      const key = t(option.name.toLowerCase())
        ? t(option.name.toLowerCase()).toUpperCase()
        : option.name;

      return {
        name: key,
        id: option.id.toLowerCase()
      };
    });

  useEffect(() => {
    setAutoCompleteOptions(getAutoCompleteOptions());

    if (
      typeof getAutoCompleteOptions().filter((x) => x.id === value)[0] !==
      'undefined'
    ) {
      const valueName = getAutoCompleteOptions().filter(
        (x) => x.id === value
      )[0].name;
      setFieldValue(valueName);
    }
  }, [value]);

  return (
    <>
      {fullWidth ? (
        <FormControl className={classes.formControlFullWidth} key={name}>
          <Autocomplete
            error={Boolean(errorMessage)}
            helperText={t(errorMessage)}
            className={classes.selectField}
            id={`select-field-label-${name}`}
            options={autoCompleteOptions}
            getOptionLabel={(option) => option.name}
            name={name}
            inputValue={fieldValue}
            autoComplete="off"
            onInputChange={(event, newInputValue) => {
              if (!readonly) {
                setFieldValue(newInputValue);
              }
            }}
            onChange={(event, newInputValue) => {
              if (!readonly && newInputValue) {
                handleChangeField({
                  target: {
                    name,
                    value: newInputValue.id
                  }
                });
              }
            }}
            onOpen={() => {
              if (!readonly) {
                setAutoCompleteOptions(getAutoCompleteOptions());

                setFieldValue('');
              }
            }}
            noOptionsText={'Sin resultados'}
            renderInput={(params) => (
              <TextField
                autoComplete="off"
                InputProps={{
                  autoComplete: 'off'
                }}
                {...params}
                label={t(name.toString())}
                variant="outlined"
              />
            )}
          />
        </FormControl>
      ) : (
        <FormControl className={classes.formControl} key={name}>
          <InputLabel shrink id={`select-field-label-${name}`}>
            {t(name.toString())}
          </InputLabel>
          <Select
            error={Boolean(errorMessage)}
            helperText={t(errorMessage)}
            className={classes.selectField}
            name={name}
            inputProps={{
              readOnly: readonly
            }}
            labelId={`select-field-label-${name}`}
            onChange={handleChangeField}
            value={value ? value.toLowerCase() : ''}
          >
            {options.map((option) => (
              <MenuItem key={option.id} value={option.id.toLowerCase()}>
                {t(option.name.toLowerCase())
                  ? t(option.name.toLowerCase()).toUpperCase()
                  : option.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </>
  );
};

export default FormSelectField;
